module.exports = __webpack_public_path__ + "img/bio_b_1000.ae4a432f.png";